// istanbul ignore file

import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1huths7";

/** Phone preset: sticky Displaying N owns the 12px gap — no feed top pad/margin. */
const containerPresetFeedCss = "cid3yha";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    presetFeed = false,
    className,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-preset-feed={presetFeed ? 'true' : undefined} className={classNames(containerCss, {
    [containerPresetFeedCss]: presetFeed
  }, className)} />;
});
const bottomPaddingCss = "betluth";
export const BottomPadding = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bottomPaddingCss, props.className)} />;
});
const endOfListContainerCss = "ewiokyv";
export const EndOfListContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(endOfListContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");